import React from 'react';

const Departments = () => {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-semibold text-slate-200 mb-6">Departments</h2>
      <p className="text-slate-400">Departments data will be displayed here.</p>
    </div>
  );
};

export default Departments;
